import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { TermsOfUseInitStepDeclaration } from "./Steps/TermsOfUseInitStep";

export const TermsOfUseStartupFlow = new FlowDefinition("TermsOfUseFlow");

TermsOfUseStartupFlow.addStep(TermsOfUseInitStepDeclaration);

TermsOfUseStartupFlow.setStartStep("TermsOfUseInit_Step");

export const TermsOfUseStartupStepDefinition = new StepDefinition({
    stepName: "TermsOfUseFlow",
    stepFlow: TermsOfUseStartupFlow,
    contextIsolation: false
})